<template>
  <div class="wrap" ref="scrollBox">
    <div class="inbox" ref="inboxRef">
      <div class="bg_w">
        <div>
          <!--          {{ customerInboxHeight }}-->
          <!--          {{ customerInboxTop }}-->
          <!--          {{ topBoxValue }}-->
          <!--          {{ dragBoxHeight }}-->
          <span class="span" style="font-size: 13px">{{ $t('common.edm') }}：</span>
          <el-select
              style="width: 150px"
              v-model="emailType"
              @change="handleChangeEmail"
              class="m-2"
              size="small"
              :default-first-option="true"
          >
            <el-option
                v-for="item in emailListTypes"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            />
          </el-select>
          <span class="span" style="font-size: 13px">{{ $t('common.contact') }}：</span>
          <el-select
              style="width: 150px !important;"
              v-model="emailSelect"
              @change="handleChangeContact"
              class="m-2"
              size="small"
          >
            <el-option
                v-for="item in emailList"
                :key="item.email"
                :label="item.email"
                :value="item.email"
            />
          </el-select>
        </div>
        <el-input
            style="width: 350px !important;"
            v-model="searchCount"
            :placeholder="$t('common.search.p.content')"
            class="input-with-select"
            clearable
            size="small"
            @clear="handleClickSearch('clear')"
            @keydown.enter.native="handleClickSearch"
        >
          <template #append>
            <el-button size="small" type="primary" :icon="Search" @click="handleClickSearch"/>
          </template>
        </el-input>
      </div>
      <div class="screen">
        <div class="screen_btn">
          <template v-if="type === 1 || type === 3">
            <ElButton size="small" @click="requestTagAllRead"
            >{{ $t('common.read.all') }}
            </ElButton
            >
            <ElButton size="small" @click="() => handleCommand('0')"
            >{{ $t('common.read.set') }}
            </ElButton
            >
            <ElButton size="small" @click="requestDelMail">{{ $t("common.delete") }}</ElButton>
            <ElButton size="small" v-if="type === 1">{{ $t('common.email.rubbish') }}</ElButton>
          </template>
          <ElButton size="small" v-if="type === 2" @click="requestDelMail(1)"
          >{{ $t('common.draft.delete') }}
          </ElButton
          >
          <ElButton size="small" v-if="type === 1">{{ $t('common.block') }}</ElButton>
          <template v-if="type === 5">
            <ElButton size="small" @click="requestTagAllRead"
            >{{ $t('common.read.all') }}
            </ElButton
            >
            <ElButton size="small" @click="() => requestDelMail(2)"
            >{{ $t('common.delete.empty') }}
            </ElButton
            >
            <ElButton size="small">{{ $t('common.block') }}</ElButton>
            <ElButton size="small" @click="() => requestDelMail(0)"
            >{{ $t('common.restore') }}
            </ElButton
            >
          </template>
        </div>
        <el-pagination
            v-model:current-page="current"
            v-model:page-size="size"
            small="small"
            v-if="total"
            layout="total, prev, pager, next, jumper"
            :total="total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
        />
      </div>

      <!--      新的移动模块-->
      <div class="Drag2" ref="DragBox">
        <div class="box" ref="box">
          <!--      <div class="left">-->
          <!--        &lt;!&ndash;左侧div内容&ndash;&gt;-->
          <!--      </div>-->
          <!--      <div class="resize" title="左右侧边栏">⋮</div>-->
          <div class="mid">
            <!--右侧div内容-->
            <div class="topBox" :style="{height:customerInboxTop+'px'}">
              <!--右上div内容-->
              <ElTable
                  v-loading="loading"
                  :data="tableData"
                  size="small"
                  :height="'100%'"
                  highlight-current-row
                  :default-sort="{ prop: 'date', order: 'descending' }"
                  @current-change="handleCurrentRowChange"
                  :cell-style="rowClassName"
                  :header-cell-style="headerClassName"
                  @row-dblclick="handleViewDetail"
                  @cell-mouse-enter="mouseEnters"
                  @cell-mouse-leave="mouseLeaves"
                  @select="handleClickSelect"
              >
                <el-table-column type="selection" width="30" fixed="left"/>
                <el-table-column width="30">
                  <template #header>
                    <img style="position: absolute;left: 6px;top:9px" src="@/assets/email/fj.svg"/>
                  </template>
                  <template #default="scope">
                    <img style="position: absolute;left: 6px;top:9px" v-if="scope.row.isExtend === 1" class="pointer"
                         src="@/assets/email/fj.svg"
                         @click.stop="() => handleDownload(scope)"/>
                  </template>
                </el-table-column>
                <el-table-column prop="contactName" :label="$t('common.contact')" width="200px"
                                 :show-overflow-tooltip="true">
                  <template #default="scope">
                    {{ scope.row.contactName != null ? scope.row.contactName : scope.row.customerName }}
                  </template>
                </el-table-column>
                <el-table-column width="18">
                  <template #default="scope">
                    <img
                        v-if="scope.row.urgent === 1"
                        src="../../assets/svg/warning.svg"
                        class="urgent-icon"
                    />
                  </template>
                </el-table-column>
                <el-table-column
                    prop="subject"
                    :label="$t('common.subject')"
                >
                  <template #default="scope">
                    <div style="position: relative; display: flex; align-items: center;">
                      <!--                      &lt;!&ndash; 紧急图标 &ndash;&gt;-->
                      <!--                      <img-->
                      <!--                          v-show="scope.row.urgent === 1"-->
                      <!--                          class="pointer"-->
                      <!--                          src="../../assets/svg/warning.svg"-->
                      <!--                          style="position: absolute; left: -6px; top: 7px; width: 16px; height: 16px;"-->
                      <!--                      />-->
                      <!-- 主题文字，包裹在 el-tooltip 内 -->
                      <el-tooltip
                          effect="dark"
                          :show-after="1200"
                          placement="top"
                      >
                        <template #content>
                          <div
                              class="tooltip-content-wrap"
                          >
                            {{ scope.row.subject }}
                          </div>
                        </template>
                        <a @click.stop="handleViewDetail(scope.row)"
                           style="max-width: 100%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                          <span v-html="highlightKeyword(scope.row.subject, searchCount)"></span>
                        </a>
                      </el-tooltip>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="remark" :label="$t('common.remark')" width="80">
                  <template #default="scope">
                    <div class="flex">
                      <!--                         @click.stop="handleRef(refMap[`${scope.row.id}`], scope.row, 1)"-->
                      <el-icon :ref="(el) => (refMap[`${scope.row.id}`] = el)"
                               @click.stop="handleClickRemark(scope.row)"
                               :color="scope.row.remark ? '#40a9ff' : '#dddddd'" style="padding-top: -2px">
                        <el-tooltip
                            v-if="emailListCheckoutTarget.remark"
                            class="box-item"
                            :content="emailListCheckoutTarget.remark"
                            placement="right"
                            :show-after="1200"
                        >
                          <Memo/>
                        </el-tooltip>
                        <Memo v-else/>
                      </el-icon>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="type" :label="$t('sys.note.jc')" :width="lang==='en'?120:50">
                  <template #default="scope">
                    <span v-if="scope.row.type === 1" style="color:#4c9f33">{{ $t('sys.note.j') }}</span>
                    <span v-else style="color:#b32518">{{ $t('sys.note.c') }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="userName" :label="$t('common.number')" width="100"/>
                <el-table-column prop="sentDate" :label="$t('common.date')" sortable width="140">
                  <template #default="scope">
                    <span v-html="highlightKeyword(scope.row.sentDate, searchCount)"></span>
                  </template>
                </el-table-column>
                <el-table-column fixed="right" :label="$t('common.cz')" :width="lang==='en'?150:100">
                  <template #default="scope">
                    <el-button
                        v-if="scope.row.type===1"
                        link
                        type="primary"
                        size="small"
                        @click.stop="handleReply(scope.row)"
                    >
                      {{ $t('common.reply') }}
                    </el-button>
                    <el-button v-else link
                               type="primary"
                               size="small"
                               @click.stop="handleResend(scope.row)">
                      {{ $t('common.resend') }}
                    </el-button>
                    <el-button link type="primary" size="small"
                               @click.stop="() => handleReplyDetail('forward',scope.row)"
                    >{{ $t('common.email.forward') }}
                    </el-button
                    >
                  </template>
                </el-table-column>
                <template #empty>
                  <el-empty :description="$t('common.data.empty')" :image="emptyUrl"/>
                </template>
              </ElTable>
            </div>
            <div title="移动到边界进行位置调整" class="mover">
              <div class="mail_info" ref="moveTarget">
                <div class="up_row move"></div>
                <div style="width: 100%;height: 26px;display: flex">
                  <div class="from over_text">
                    {{ $t('common.email.from') }}：{{ currentMail.mailBody?.from }}
                  </div>
                  <div class="to over_text" ref="toRef">
                    <el-popover
                        v-if="formatText(currentMail.mailRecipientVOList, 'to')"
                        :visible="visibleTo"
                        width="500"
                        :content="formatText(currentMail.mailRecipientVOList, 'to')"
                        :effect="'dark'"
                        popper-class="visible"
                    >
                      <template #reference>
                    <span @mouseenter="showPopover(formatText(currentMail.mailRecipientVOList, 'to'),'to')"
                          @mouseleave="delayedHidePopover('to')">{{
                        $t('common.email.to')
                      }}：{{ formatText(currentMail.mailRecipientVOList, 'to') }}</span>
                      </template>
                      <div @mouseenter="keepPopoverVisible('to')" @mouseleave="hidePopover('to')">
                        {{ formatText(currentMail.mailRecipientVOList, 'to') }}
                      </div>
                    </el-popover>
                    <template v-else>
                      {{ $t('common.email.to') }}：{{ formatText(currentMail.mailRecipientVOList, 'to') }}
                    </template>
                  </div>
                  <div class="cc over_text">
                    <el-popover
                        v-if="formatText(currentMail.mailRecipientVOList, 'cc')"
                        :visible="visibleCC"
                        width="500"
                        :content="formatText(currentMail.mailRecipientVOList, 'cc')"
                        :effect="'dark'"
                        popper-class="visible"
                    >
                      <template #reference>
                <span
                    @mouseenter="showPopover(formatText(currentMail.mailRecipientVOList, 'cc'),'cc')"
                    @mouseleave="delayedHidePopover('cc')"
                >
                {{ $t('common.cc') }}：{{ formatText(currentMail.mailRecipientVOList, 'cc') }}
                </span>
                      </template>
                      <div @mouseenter="keepPopoverVisible('cc')" @mouseleave="hidePopover('cc')">
                        {{ formatText(currentMail.mailRecipientVOList, 'cc') }}
                      </div>
                    </el-popover>
                    <template v-else>
                      {{ $t('common.cc') }}：{{ formatText(currentMail.mailRecipientVOList, 'cc') }}
                    </template>
                  </div>
                </div>
                <div class="down_row move"></div>
              </div>
            </div>
            <div class="downBox" :style="{height:`calc(100% - ${customerInboxTop + 10}px)`}">
              <!--右下div内容-->
              <!--              <iframe ref="pageframe" id="pageframe"-->
              <!--                      :srcdoc="iframeContent"-->
              <!--                      frameborder="0"-->
              <!--                      :style="{width: '100%',height: '100%'}"-->
              <!--                      :class="detailLoading?'scroll':'scroll loaded'"-->
              <!--              >-->
              <!--                <p>Your browser does not support preview features, please download Google browser or other modern-->
              <!--                  browsers.</p>-->
              <!--              </iframe>-->
              <div v-loading="detailLoading" style="width: 100%;height: 100%">
                <iframe ref="pageframe" id="pageframe" :srcdoc="iframeContent"
                        frameborder="0"
                        :style="{width: '100%',height: '100%'}"
                        :class="detailLoading?'scroll':'scroll loaded'"
                >
                  <p>Your browser does not support preview features, please download Google browser or other modern
                    browsers.</p>
                </iframe>
                <div v-if="isDragging" id="mask"
                     :style="{width: '100%',height:`calc(100% - ${customerInboxTop + 10}px)`,background:'rgba(0,0,0,0)',position:'absolute',zIndex:999,top:customerInboxTop+'px'}">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--   添加备注   -->
      <Remark v-if="visitableRemark" v-model="visitableRemark" @close="closeRemark" :isHeadLine="false"
              :currentItem="currentItem" @getList="getCustomerMailRecordApisList" :mailId="true"></Remark>
    </div>
  </div>
</template>
<script>
import {onMounted, ref, watch, computed, defineEmits, nextTick} from "vue";
import {
  getDefaultMailConfig,
  tagMail,
  tagAllRead,
  delMail,
  getMailDetails,
} from "../../api/index";
import {ElMessage} from "element-plus";
import {useRoute, useRouter} from "vue-router";
import {useStore} from "vuex";
import {Search} from "@element-plus/icons-vue";
import {getContactEmailListApis, getCustomerMailRecordApis, requestUpdateMailRemark} from "@/api/mail";
import {emptyUrl, htmlReg} from '@/utils/statusParams'
import {debouncePlus, throttle} from "@/utils/mylodash"
import {formatSize} from "@/utils/file";
import {getToken} from "@/utils/auth";
import {addImgOnErrorAttribute, containsHtmlTags, convertLinksToHTML, convertToHTML} from "@/utils/iframe";
import {i18n} from "@/lang";
import {getScaleValue} from "@/utils/view";
import Remark from "@/components/Remark/index.vue";
import {highlightKeyword} from "@/utils/util";
import {replaceEmptyPTagsWithBr, resetCss} from "@/utils/TinyMCE";
import sessionStore from "@/utils/sessionStore";

export default {
  components: {Remark},
  methods: {highlightKeyword, formatSize},
  // (-1:失败邮件,1:收件箱,2:草稿箱,3:已发送,4:已删除,5:垃圾邮件)
  props: ["type", 'targetCheckoutItem'],
  setup(props, context) {
    const route = useRoute()
    const tableHeight = ref(200);
    const inboxRef = ref(null)
    const configId = ref("");
    const emailList = ref([]);
    const searchCount = ref("");
    const current = ref(1);
    const size = ref(20);
    const total = ref(0);
    const tableData = ref([]);
    const loading = ref(false);
    const multipleTableRef = ref(null);
    const multipleSelection = ref([]);
    const currentMail = ref({});
    const router = useRouter();
    const iframeContent = ref('');
    const lang = computed(() => store.state.system.langLocal)

    // 上下拖动事件
    const topBoxValue = ref(0);
    const downBoxValue = ref(0)
    // 移动
    const moveTarget = ref(null);
    const scrollBox = ref(null);
    const isDragging = ref(false);
    const initialMouseY = ref(0)
    const elementLeft = ref(0)

    const DragBox = ref()
    // 记录容器的最大高度
    const dragBoxHeight = ref(0)

    const emailListTypes = ref([{label: i18n.global.t('common.all'), value: 0}, {
      label: i18n.global.t('sys.note.j'),
      value: 1
    }, {
      label: i18n.global.t('sys.note.c'),
      value: 2
    },])
    // 选中的 邮件
    const emailType = ref(0)
    const userInfo = computed(() => store.state.user.userInfo)
    // 选中的 联系人
    const emailSelect = computed(() => {
      return props.targetCheckoutItem.islink ? props.targetCheckoutItem.targetCheckoutItem : emailSelectTarget.value
    })
    const emailSelectTarget = ref(i18n.global.t('common_all'))

    const store = useStore();
    const teamId = computed(() => store.state.email.teamID);

    watch(() => emailSelect.value, () => {
      if (props.targetCheckoutItem.islink) {
        getCustomerMailRecordApisList()
      }
    })

    const commandList = [1, 0, 1, 0];

    async function handleDownload(scope) {
      // const result = await requestMailAccessory({ id: scope.row.id });
      // if (result.code !== 200) {
      //   ElMessage.error(result.message);
      //   return;
      // }
      window.open(`${location.origin}/email/detail/${scope.row.id}/${JSON.stringify(scope.row)}`);
    }

    const handleViewDetail = (row) => {
      //邮件已读
      multipleSelection.value = [row]
      requestTagMail(commandList[0], 'isRead');
      // 没有 type 来源，这里指定 type 类型
      const targetType = row.type === 1 ? 1 : 3;
      window.open(`${location.origin}/email/detail/${row.mailId}/${JSON.stringify({
        flag: row.flag ? row.flag : 0,
        isExtend: row.isExtend ? row.isExtend : 0,
        from: row.from,
        customerId: row.customerId,
      })}/${targetType}`);
      getCustomerMailRecordApisList()
    }

    // 回复
    function handleReply(row) {
      localStorage.setItem('reSend', JSON.stringify(row))
      const query = {id: row.mailId, customerId: row.customerId}
      // router.push({
      //   path: '/email/write_mail',
      //   query: {id: row.mailId, customerId: row.customerId},
      // });
      const queryString = new URLSearchParams(query).toString();
      // 拼接完整 URL（假设是 hash 模式或 history 模式可视项目结构调整）
      const url = `${location.origin}/email/write_mail?${queryString}`;
      // 在新标签页打开
      window.open(url, '_blank');
    }

    function handleResend(row) {
      localStorage.setItem('reSend', JSON.stringify(row))
      const query = {
        id: row.mailId,
        flag: row.flag,
        type: "resend",
        mailType: 3 || 2,
        customerId: route.params.userId,
      };
      if (row.flag === 0 && row.customerId) {
        query.customerId = row.customerId;
      }
      // router.push({
      //   path: '/email/write_mail',
      //   query,
      // });
      const queryString = new URLSearchParams(query).toString();

      // 拼接完整 URL（假设是 hash 模式或 history 模式可视项目结构调整）
      const url = `${location.origin}/email/write_mail?${queryString}`;

      // 在新标签页打开
      window.open(url, '_blank');
    }


    function handleReplyDetail(stringType = '', row) {
      if (!row.mailId) {
        return;
      }
      const query = {
        id: row.mailId,
        type: stringType,
        mailType: 1,
        customerId: row.customerId
      }
      if (stringType === "") {
        delete query.type;
      }
      console.log(query, 'payload')
      // router.push({
      //   path: '/email/write_mail',
      //   query,
      // });
      // 构造 query 参数字符串
      const queryString = new URLSearchParams(query).toString();

      // 拼接完整 URL（假设是 hash 模式或 history 模式可视项目结构调整）
      const url = `${location.origin}/email/write_mail?${queryString}`;

      // 在新标签页打开
      window.open(url, '_blank');
    }

    async function getConfig() {
      const res = await getDefaultMailConfig(teamId);
      const {id} = res.result;
    }


    function handleSizeChange() {
    }

    function handleCurrentChange(page) {
      current.value = page;
      // getMailList();
      getCustomerMailRecordApisList()
    }

    function handleSelectionChange(val) {
      multipleSelection.value = val;
    }

    async function requestTagMail(tag) {
      const result = await tagMail({
        [type]: tag,
        mailIdList: multipleSelection.value.map(item => item.id),
      });
      if (result.code !== 200) {
        ElMessage.error(result.message);
        return;
      }
      // getMailList();
      getCustomerMailRecordApisList()
    }

    async function requestTagAllRead() {
      const result = await tagAllRead();
      // getMailList();
      getCustomerMailRecordApisList()
    }

    async function requestDelMail(flag = 1, isSelect) {
      if (isSelect) {
        multipleSelection.value.push(isSelect)
      }
      if (!multipleSelection.value.length) {
        ElMessage.error(i18n.global.t('sys.tip.unselect.email'));
        return;
      }
      const result = await delMail({
        type: flag, // 0 还原  1 已删除 2彻底删除
        mailIdList: multipleSelection.value.map(item => item.mailId),
        originalPosition: isSelect?.originalPosition,
      });
      if (result.code !== 200) {
        ElMessage.error(result.msg);
        return;
      }
      ElMessage.success(i18n.global.t("sys.message.success.delete"));
      setTimeout(() => {
        // getMailList();
        getCustomerMailRecordApisList()
      }, 1500);
    }

    const activeItems = ref({})
    const detailLoading = ref(false)
    const getTargetMailId = ref("")

    async function handleCurrentRowChange(current) {
      if (current) {
        getTargetMailId.value = current.mailId;
      }
      activeItems.value = current
      if (current !== null) {
        detailLoading.value = true
        try {
          const result = await getMailDetails({id: current.mailId});
          let content = result.result?.mailBody?.content;
          const insertionContent = `<script>
            function errorImage(img) {
                img.onerror = null;
                img.src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAIAAACQd1PeAAAADElEQVR42mP4//8/AAX+Av4zEpUUAAAAAElFTkSuQmCC"
            }
        <\/script>`;
          if (!content) {
            iframeContent.value = replaceEmptyPTagsWithBr(resetCss + '')
          } else {
            if (containsHtmlTags(content)) {
              const replacedHtmlString = addImgOnErrorAttribute(content)
              const res = replacedHtmlString.replace(/(<html[^>]*>)/, '$1' + insertionContent);
              iframeContent.value = replaceEmptyPTagsWithBr(resetCss + res);
            } else {
              if (content.indexOf('https://s3gw.cmbimg.com') !== -1) {
                iframeContent.value = replaceEmptyPTagsWithBr(resetCss + content);
              } else {
                iframeContent.value = replaceEmptyPTagsWithBr(resetCss + convertLinksToHTML(convertToHTML(content)));
              }
            }
          }
          currentMail.value = result.result;
          detailLoading.value = false
        } catch (e) {
          detailLoading.value = false
        }
      }
    }

    function handleCommand(val) {
      if (!multipleSelection.value.length) {
        ElMessage.error(i18n.global.t('sys.tip.unselect.email'));
        return;
      }
      requestTagMail(val);
    }

    function formatText(list, type) {
      if (!list || !list.length) {
        return '';
      }
      const infoMap = list.reduce((prev, item) => {
        if (!prev[item.mailType]) {
          prev[item.mailType] = [];
        }
        prev[item.mailType].push(item.mail);
        return prev;
      }, {});
      return infoMap[type] ? infoMap[type].join(',') : '';
    }

    function handleSettingStress(scope, type) {
      multipleSelection.value = [scope.row];
      handleCommand(type);
    }


// 获取邮件配置
    const getCustomerMailRecordApisList = async () => {
      loading.value = true
      const customerId = window.localStorage.getItem('customerId');
      const teamId = sessionStore.get('teamId')
      const targetObj = {
        customerId,
        "pageNo": current.value,
        "pageSize": size.value,
        "search": isClear.value ? "" : searchCount.value,
        teamId,
        email: emailSelect.value === i18n.global.t('common_all') ? "" : emailSelect.value,
        "type": emailType.value
      }
      let res = await getCustomerMailRecordApis(targetObj);
      if (res.code !== 200) {
        ElMessage.error(res.message)
        return
      }
      loading.value = false
      const {records} = res.result;
      tableData.value = records;
      total.value = res.result.total;
      current.value = res.result.current;
      size.value = res.result.size;
    }


    const isClear = ref(false)
// 点击搜索框
    const handleClickSearch = (flag) => {
      if (flag === "clear") {
        isClear.value = true;
      } else {
        isClear.value = false;
      }
      getCustomerMailRecordApisList()
    }

    const getContactEmailListApisList = async () => {
      // customerId 不同步问题
      const customerId = router.currentRoute.value.params
      window.localStorage.setItem('customerId', customerId.userId);
      let res = await getContactEmailListApis({customerId: customerId.userId});
      if (res.code !== 200) {
        ElMessage.error(res.message);
        return;
      }
      emailList.value = [...res.result, {
        email: i18n.global.t('common_all'),
        contactEmail: i18n.global.t('common_all'),
      }].filter(item => item.email !== "");
    }

    // 页面进行缩放
    const adjustContentPosition = debouncePlus(() => {
      console.log('resize')
      localStorage.setItem("resize", true)
      router.go(0)
    }, 200)

    onMounted(async () => {
      await store.dispatch("system/getTargetHeight", {userId: userInfo.value.id})
      dragControllerUD()
      await nextTick()
      if (DragBox.value) {
        dragBoxHeight.value = DragBox.value.offsetHeight;
      }
      document.addEventListener('mousemove', onDragCall);
      document.addEventListener('mouseup', stopDragCall);
      await getContactEmailListApisList();
      await getCustomerMailRecordApisList()

      window.addEventListener('resize', adjustContentPosition);
    });

    const handleChangeEmail = () => {
      getCustomerMailRecordApisList()
    }
    const handleChangeContact = (val) => {
      emailSelectTarget.value = val
      context.emit('change', {islink: false})
      getCustomerMailRecordApisList()
    }

    async function setRemark(id, val) {
      if (val.length > 30) {
        ElMessage.warning(i18n.global.t('common.email.setBlockSize'))
        activeItems.value.remark = "";
        return;
      } else {
        const result = await requestUpdateMailRemark({id, remark: val});
        if (result.code !== 200) {
          ElMessage.error(result.message);
          return;
        }
      }
    }

    const customerInboxHeight = computed(() => store.state.system.customerInboxHeight)
    // 优化--分辨率问题
    const customerInboxTop = computed(() => {
      return topBoxValue.value !== 0
          ? topBoxValue.value
          : store.state.system.customerInboxTop > dragBoxHeight.value
              ? dragBoxHeight.value
              : store.state.system.customerInboxTop;
    })

    const elementTopRaw = ref(customerInboxTop.value);
    const elementTop = computed({
      get() {
        return elementTopRaw.value;
      },
      set(newValue) {
        elementTopRaw.value = newValue;
      },
    });

    const pageframeHeightRaw = ref(customerInboxHeight.value);
    const pageframeHeight = computed({
      get() {
        return pageframeHeightRaw.value;
      },
      set(newValue) {
        pageframeHeightRaw.value = newValue;
      },
    });

    function startDrag(event) {
      // 阻止 iframe 事件响应
      // document.getElementById("pageframe").style.pointerEvents = "none";
      isDragging.value = true;
      initialMouseY.value = event.clientY;
    }

    const saveTargetHeight = debouncePlus((userId, pageframeHeight, elementTop) => {
      store.dispatch("system/settingTargetHeight", {
        userId,
        customerInboxHeight: pageframeHeight,
        customerInboxTop: elementTop
      });
    }, 200); // 300ms 防抖延迟

    const onDragCall = (event) => {
      // 拖拽中更新元素位置
      if (isDragging.value) {
        requestAnimationFrame(() => {
          const deltaY = event.clientY - initialMouseY.value;
          elementTop.value += deltaY;
          initialMouseY.value = event.clientY;
          // 限制元素在容器内上下移动
          const tagNumber = getScaleValue(160)
          elementTop.value = Math.max(30, Math.min(inboxRef.value.clientHeight, elementTop.value > inboxRef.value.clientHeight - tagNumber ? inboxRef.value.clientHeight - tagNumber : elementTop.value));
          tableHeight.value = elementTop.value;
          pageframeHeight.value = scrollBox.value.offsetHeight - elementTop.value
          saveTargetHeight(userInfo.value.id, pageframeHeight.value, elementTop.value);
        })
      } else {
        stopDragCall()
      }
    }

    document.onmouseup = function (e) {
      document.onmousemove = null;
      document.onmouseup = null;
    };

    function stopDragCall() {
      // 结束拖拽
      isDragging.value = false;
    }

    const rowClassName = ({row, column, rowIndex, columnIndex}) => {
      if (columnIndex === 4 || columnIndex === 3 || columnIndex === 2 || columnIndex === 0 || columnIndex === 1) {
        return {textAlign: 'left'}
      } else {
        return {textAlign: 'center'}
      }
    }

    const headerClassName = ({row, column, rowIndex, columnIndex}) => {
      if (columnIndex === 4 || columnIndex === 3 || columnIndex === 2 || columnIndex === 0 || columnIndex === 1) {
        return {'text-align': 'left',}
      } else {
        return {'text-align': 'center'}
      }
    }


    const visibleTo = ref(false)
    const visibleCC = ref(false)

    const hidePopoverTimeout = ref(false)

    function showPopover(string = '', flag) {

      if (moveTarget.value) {
        const itemWidth = Math.round((moveTarget.value.clientWidth - 40) * (1 / 3))
        const stringWidth = string.pxWidth('normal 12px PingFangSC, PingFang SC')
        if (stringWidth + 20 > itemWidth) {
          if (flag === "to") {
            visibleCC.value = false;
            visibleTo.value = true;
          } else if (flag === "cc") {
            visibleTo.value = false;
            visibleCC.value = true;
          }
          if (hidePopoverTimeout.value) {
            clearTimeout(hidePopoverTimeout.value);
            hidePopoverTimeout.value = null;
          }
        }
      }
    }

    function delayedHidePopover(flag) {
      hidePopoverTimeout.value = setTimeout(() => {
        flag === "to" ? visibleTo.value = false : visibleCC.value = false;
      }, 200); // Adjust delay as necessary
    }

    function keepPopoverVisible(flag) {
      if (hidePopoverTimeout.value) {
        clearTimeout(hidePopoverTimeout.value);
        hidePopoverTimeout.value = null;
      }
      flag === "to" ? visibleTo.value = true : visibleCC.value = true;
    }

    function hidePopover(flag) {
      flag === "to" ? visibleTo.value = false : visibleCC.value = false;
    }


    const refMap = ref([])
    const tempRef = ref(null)
    const visiblePopover = ref(false)
    const emailListCheckoutTarget = ref({remark: ''})
    const handleRef = debouncePlus((ref, item, type) => {
      tempRef.value = ref
      visiblePopover.value = true;
      emailListCheckoutTarget.value = item;
    }, 500)

    const hidePopoverTimeoutModel = ref(false)
    // 这里是开始点
    const mouseEnters = debouncePlus((row) => {
      emailListCheckoutTarget.value = row;
    }, 200)

    const mouseLeaves = () => {
      hidePopoverTimeoutModel.value = setTimeout(() => {
        visiblePopover.value = false;
      }, 300);
    }
    const keepPopoverVisibleModel = () => {
      if (hidePopoverTimeoutModel.value) {
        clearTimeout(hidePopoverTimeoutModel.value);
        hidePopoverTimeoutModel.value = null;
      }
      visiblePopover.value = true;
    }

    const hidePopoverModel = () => {
      visiblePopover.value = false;
    }

    const cancelPopover = () => {
      visiblePopover.value = false;
      emailListCheckoutTarget.value.remark = ''
    }

    const handleClickSelect = (val) => {
      console.log(val, 'val')
      multipleSelection.value = val;
    }


    // 弹窗进行编辑备注
    const visitableRemark = ref(false)
    const currentItem = ref({remark: ""})
    const handleClickRemark = (row) => {
      const {id} = row
      console.log(id, row, 'id')
      currentItem.value = row
      visitableRemark.value = true
    }
    const closeRemark = () => {
      visitableRemark.value = false
    }


    function dragControllerUD() {
      var resize = document.getElementsByClassName("move");
      var topBox = document.getElementsByClassName("topBox");
      var downBox = document.getElementsByClassName("downBox");
      var box = document.getElementsByClassName("mid");
      console.log(document.getElementsByClassName("move"), resize.length, 'resize.length');
      for (let i = 0; i < resize.length; i++) {
        // 鼠标按下事件
        resize[i].onmousedown = function (e) {
          console.log(resize[i].top);
          //颜色改变提醒
          resize[i].style.background = "#818181";
          // 100 这里是 有上面的 操作栏的高度
          var startY = e.clientY + 100;
          resize[i].top = resize[i].offsetTop;
          // 鼠标拖动事件
          document.onmousemove = function (e) {
            isDragging.value = true
            var endY = e.clientY;
            var moveLen = resize[i].top + (endY - startY); // （endY - startY）=移动的距离。resize[i].top+移动的距离=上边区域最后的高度
            var maxT = box[0].clientHeight - resize[i].offsetHeight; // 容器高度 - 上边区域的高度 = 下边区域的高度

            if (moveLen < 30) moveLen = 30; // 上边区域的最小高度为50px
            if (moveLen > maxT - 30) moveLen = maxT - 35; //下边区域最小高度为150px

            resize[i].style.top = moveLen; // 设置上边区域的高度

            for (let j = 0; j < topBox.length; j++) {
              topBox[j].style.height = moveLen + "px";
              topBoxValue.value = moveLen
              downBox[j].style.height = box[0].clientHeight - moveLen - 10 + "px";
              downBoxValue.value = box[0].clientHeight - moveLen - 10

              console.log(moveLen, box[0].clientHeight - moveLen - 10, 'mover')
              saveTargetHeight(userInfo.value.id, box[0].clientHeight - moveLen - 10, moveLen);
            }
          };
          // 鼠标松开事件
          document.onmouseup = function () {
            isDragging.value = false
            //颜色恢复
            resize[i].style.background = "#d6d6d6";
            document.onmousemove = null;
            document.onmouseup = null;
            resize[i].releaseCapture && resize[i].releaseCapture(); //当你不在需要继续获得鼠标消息就要应该调用ReleaseCapture()释放掉
          };
          resize[i].setCapture && resize[i].setCapture(); //该函数在属于当前线程的指定窗口里设置鼠标捕获
          return false;
        };
      }
    }

    return {
      lang,
      handleReplyDetail,
      topBoxValue,
      dragBoxHeight,
      DragBox,
      dragControllerUD,
      currentItem,
      closeRemark,
      visitableRemark,
      handleClickRemark,
      handleClickSelect,
      cancelPopover,
      emailListCheckoutTarget,
      hidePopoverModel,
      keepPopoverVisibleModel,
      mouseLeaves,
      mouseEnters,
      handleRef,
      visiblePopover,
      tempRef,
      refMap,
      showPopover,
      delayedHidePopover, keepPopoverVisible, hidePopover,
      detailLoading,
      visibleTo,
      visibleCC,
      handleDownload,
      handleViewDetail,
      handleResend,
      headerClassName,
      rowClassName,
      pageframeHeight,
      elementLeft,
      elementTop,
      stopDragCall,
      onDragCall,
      startDrag,
      scrollBox,
      moveTarget,
      setRemark,
      configId,
      emailList,
      tableData,
      current,
      size,
      total,
      loading,
      multipleTableRef,
      handleCommand,
      currentMail,
      handleSizeChange,
      handleCurrentChange,
      handleCurrentRowChange,
      handleSettingStress,
      handleSelectionChange,
      requestTagAllRead,
      requestDelMail,
      getCustomerMailRecordApisList,
      getContactEmailListApisList,
      emailListTypes,
      emailType,
      emailSelect,
      searchCount,
      Search,
      handleClickSearch,
      handleReply,
      formatText,
      iframeContent,
      handleChangeEmail,
      handleChangeContact,
      tableHeight,
      inboxRef,
      emptyUrl,
      isDragging,
      customerInboxHeight,
      customerInboxTop,
      elementTopRaw,
      pageframeHeightRaw
    };
  },
}
;
</script>
<style lang="less" scoped>
:deep(.el-table .read_0) {
  font-weight: 700 !important;
}

.wrap {
  background-color: rgb(245, 245, 245);
  padding: 8px 8px 0px 8px;
  height: -webkit-fill-available !important;

  .inbox .bg_w {
    & :deep(.el-select) {
      width: 150px !important;
    }
  }
}

.fx-j-e {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
}

.pointer {
  cursor: pointer;
}

.inbox {
  background-color: #fff;
  position: relative;
}

.bg_w {
  padding: 4px;
  display: flex;
  align-items: center;

  .span {
    font-size: 13px;
    font-weight: normal;
    color: rgba(0, 0, 0, .65);
  }
}

.input-with-select {
  width: 350px;
  margin-right: 10px;
}

.screen {
  display: flex;
  justify-content: space-between;
  padding: 6px 0;
  background-color: #f5f5f5;

  .el-button + .el-button {
    margin-left: 2px;
  }

  .el-dropdown {
    margin-left: 2px;
  }
}

.current_mail {

  .mail_info {
    display: flex;
    flex-direction: column;
    height: 30px;
    align-items: center;
    background: rgb(229, 229, 229);
    //user-select: text;
    cursor: n-resize;
    transform: translateZ(0);
    will-change: transform;
    font-family: "PingFangSC, PingFang SC";

    & > div:nth-of-type(2) {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      padding: 0px 20px;
      height: 26px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 12px;
      cursor: text !important;

      & > div {
        width: 33.33%;
        min-width: 33.33% !important;
        max-width: 33.33% !important;
      }
    }
  }
}

.box_titles {
  position: relative;
  height: max-content;
  border-top: 1px solid #e8e8e8;
}

.inner_card {
  margin: 30px 0px 30px 40px;
}

.sp_box {
  width: 45% !important;
}

.footer_box {
  display: flex !important;
  justify-content: flex-end !important;
  align-items: center !important;

  .el-button {
    margin: 0px 10px;
  }
}

.box_titles:nth-of-type(1)::after {
  content: '选择建档邮箱';
  position: absolute;
  top: -12px;
  left: 34px;
  text-align: center;
  font-size: 16px;
  color: black;
  background: white;
  padding: 0px 10px;
}

.box_titles:nth-of-type(2)::after {
  content: '选择归档客户';
  position: absolute;
  top: -12px;
  left: 34px;
  text-align: center;
  font-size: 16px;
  color: black;
  background: white;
  padding: 0px 10px;
}

.box_titles:nth-of-type(3)::after {
  content: '选择已有联系人';
  position: absolute;
  top: -12px;
  left: 34px;
  text-align: center;
  font-size: 16px;
  color: black;
  background: white;
  padding: 0px 10px;
}

.box_titles_created {
  position: relative;
  height: max-content;
  border-top: 1px solid #e8e8e8;
}

.box_titles_created::after {
  content: '新建联系人';
  position: absolute;
  top: -12px;
  left: 34px;
  text-align: center;
  font-size: 16px;
  color: black;
  background: white;
  padding: 0px 10px;
}

.sp_buttons {
  margin-left: 20px;
  position: absolute;
  left: 105%;
}

.my_forms {
  margin-top: 20px;
}

:deep(.el-form-item__content) {
  flex-wrap: nowrap !important;
}

.wrap :deep(.el-form-item) {
  margin: 20px 0 0;
}

.el-form-item__content > div {
  position: relative;
}

:deep(.el-scrollbar__bar.is-horizontal) {
  height: 0 !important;
}

:deep(.el-scrollbar__wrap) {
  overflow-x: hidden !important;
}

:deep(.el-input-group__append) {
  padding: 0 20px 0 0;
}

:deep(.el-input-group__append button.el-button) {
  background: #5a9cf8;
  color: white;
  width: 76px;
  border-radius: 0px 4px 4px 0px !important;
}

.bg_w {
  padding: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  & > div {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: max-content;
  }

  .span {
    width: max-content;
    min-width: max-content;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.65);
  }
}

:deep(.el-select) {
  margin-right: 20px;
}


.scroll_out_box {
  position: relative;
  min-height: calc(100vh - 164px) !important;
  max-height: calc(100vh - 164px) !important;
}

.mail_info {
  width: 100%;
  height: 26px;
}

.screen_btn {
  button:nth-of-type(1) {
    margin-left: 0px !important;
  }

  button {
    margin-left: 2px !important;
  }
}

.up_row, .down_row {
  width: 100%;
  height: 2px !important;
  cursor: row-resize !important;
}

.over_text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 26px;
  width: 33.33%;
  text-align: left;
  color: black !important;
}

iframe {
  opacity: 0;
  transition: opacity 0.5s ease-in-out;
}

iframe.loaded {
  opacity: 1;
}

:deep(.el-popper) {
  max-width: 45% !important;
}

.visible {
  padding: 0px !important;

  & > div {
    margin: -12px !important;
    padding: 8px !important;
  }
}

.sp_model_popover {
  padding: 0px !important;

  & > div {
    margin: -12px !important;
    padding: 12px !important;
  }
}

.flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

:deep(.el-scrollbar__bar.is-horizontal) {
  height: 6px !important;
}

.Drag2 {
  height: calc(100vh - 230px);
}

/*包围div样式*/
.box {
  width: 100%;
  height: 100%;
  margin: 0px 0px 20px 0px;
  overflow: hidden;
  //box-shadow: -1px 9px 10px 3px rgba(0, 0, 0, 0.11);
}

/*左侧div样式*/
.left {
  width: calc(32% - 10px); /*左侧初始化宽度*/
  height: 100%;
  background: #71ad88;
  float: left;
}

/* 拖拽区div样式 */
.resize {
  cursor: w-resize;
  float: left;
  position: relative;
  top: 45%;
  background-color: #d6d6d6;
  border-radius: 5px;
  margin-top: -10px;
  width: 10px;
  height: 50px;
  background-size: cover;
  background-position: center;
  /*z-index: 99999;*/
  font-size: 32px;
  color: white;
}

/*拖拽区鼠标悬停样式*/
//.movers:hover {
//  color: #444444;
//}

/*右侧div'样式*/
.mid {
  float: left;
  width: 100%; /*右侧初始化宽度*/
  height: calc(100vh - 29.5vh);
  background: #f3f3f3;
  box-shadow: -1px 4px 5px 3px rgba(0, 0, 0, 0.11);
  /*上方div'样式*/

  .topBox {
    height: 60%;
    background-color: #3ff53f;
    display: flex;
  }

  /*下方div'样式*/

  .downBox {
    //height: calc(40% - 32px);
    //background-color: #f0fd35;
    background: white !important;
    display: flex;
  }

  /* 拖拽区div样式 */

  .mover {
    padding: 0px 20px;
    //cursor: s-resize;
    cursor: text;
    width: 100%;
    height: 30px;
    background-color: #d6d6d6;
    border-radius: 5px;
    text-align: center;
    line-height: 3px;
    font-size: 12px;
    user-select: text; /* 启用文本选择 */
  }

  /*拖拽区鼠标悬停样式*/

  .mover:hover {
    color: #444444;
  }
}

.urgent-icon {
  width: 15px;
  height: 15px;
  position: relative;
  top: 3px;
}

</style>
